import { DataSystemDetails } from '@ketch-com/windlass/dist/dataSentry/v1/systems/systems'
import { useCallback, useState } from 'react'
import { useDebounce } from 'react-use'

export function useTableFilters(initialPageSize = 5) {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: initialPageSize,
  })
  const [searchQuery, setSearchQuery] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const [dataSystemFilterValue, setDataSystemFilterValue] = useState<DataSystemDetails | undefined>(undefined)
  const handleDataSystemFilterValue = useCallback((value: DataSystemDetails | undefined) => {
    setDataSystemFilterValue(value)
    setPaginationModel(prev => ({ ...prev, page: 0 }))
  }, [])
  const [,] = useDebounce(
    () => {
      if (searchQuery) {
        setDebouncedSearchQuery(searchQuery)
        setPaginationModel(prev => ({ ...prev, page: 0 }))
      } else {
        setDebouncedSearchQuery('')
      }
    },
    300,
    [searchQuery],
  )

  return {
    searchQuery,
    debouncedSearchQuery,
    setSearchQuery,
    dataSystemFilterValue,
    setDataSystemFilterValue: handleDataSystemFilterValue,
    paginationModel,
    setPaginationModel,
  }
}
